import newsLinks from './newsLinks';
import { buildCommonTabs } from '../../model/transformers/taxonomyBuilder';
import { channelObjects } from '../../../../shared/model/constants/channels';

export default {
  title: 'Explore sold commercial real estate',
  tabs: [
    ...buildCommonTabs(channelObjects.Sold),
    {
      name: 'Popular Searches',
      links: newsLinks,
    },
  ],
};
